import { createFileRoute } from "@tanstack/react-router";
import DiagnosedDepressionAt25 from "@/pages/articles/DiagnosedDepressionAt25";
export const Route = createFileRoute("/diagnosed-with-depression-at-25")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Diagnosed With Depression At 25 | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression at 25 is more common than you think. Learn about TMS, SAINT TMS, and treatment options for young adults in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Diagnosed With Depression At 25 | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression at 25 is more common than you think. Learn about TMS, SAINT TMS, and treatment options for young adults in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/diagnosed-with-depression-at-25",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/diagnosed-with-depression-at-25",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DiagnosedDepressionAt25 />;
}
